import { LocationHttpService } from './../../../http/location-http.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-location-new',
    templateUrl: './location-new.component.html',
    styles: [],
})
export class LocationNewComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        private locationHttpService: LocationHttpService,
        private router: Router,
        public location: Location,
        private activatedRoute: ActivatedRoute
    ) {}

    newLocationForm = this.fb.group(
        {
            locationName: [null, Validators.required],
            branchId: [null, Validators.required],
            cost: [null, Validators.required],
            isPublished: [false],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    branches: any[] = [];

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.branches = data.data;
        });
    }

    onSubmit() {
        this.newLocationForm.markAsTouched();
        if (this.newLocationForm.valid) {
            this.formBusy = true;
            this.locationHttpService.newLocation(this.newLocationForm.value).subscribe(
                () => {
                    this.router.navigateByUrl('location-list', {
                        state: { hasState: true, type: 'success', message: 'Location Created successfully' },
                    });
                },
                () => {
                    this.formBusy = false;
                    this.newLocationForm.setErrors({ exists: true });
                }
            );
        }
    }
}
